<script>

import Layout from "./../../layouts/main";
import appConfig from "./../../../app.config";
import ServiceCompanyDetail from "@/views/service-company/detail/detail";
import ManufacturerDetail from "@/views/manufacturer/detail/detail";
import CustomerDetail from "@/views/customer/detail/detail";

export default {
  page: {
    title: '',
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      belong_id: null,
      belong_type: 'manufacturer',//customer manufacturer service_company
    };
  },
  components: {
    Layout,
    ServiceCompanyDetail,
    ManufacturerDetail,
    CustomerDetail,
  },
  computed: {

  },
  watch: {

  },
  beforeMount() {
    const user = localStorage.getItem('user');
    if (user) {
      const userObj = JSON.parse(user);
      this.belong_id = userObj.org.id;
      this.belong_type = userObj.user_type;
    }
    if (this.belong_type === 'manufacturer') {
      this.$options.page.title = this.$t('menu.business-partner.manufacturer');
    } else if (this.belong_type === 'customer') {
      this.$options.page.title = 'menu.business-partner.customer';
    } else if (this.belong_type === 'service_company') {
      this.$options.page.title = 'menu.business-partner.service-company';
    } else {
      this.$options.page.title = this.$t('page.business-info');
    }
  },

  methods: {

  },
};
</script>

<template>
  <Layout>
    <service-company-detail
        v-if="belong_type === 'service_company'"
        :company-id="belong_id"
        source="user-center"
        account-permission-code="user.company.get"
        account-edit-permission-code="user.company.patch"
        other-permission-code="user.company.get"
        other-edit-permission-code="user.company.patch"
    ></service-company-detail>
    <manufacturer-detail
        v-if="belong_type === 'manufacturer'"
        :manufacturer-id="belong_id"
        source="user-center"
        account-permission-code="user.company.get"
        account-edit-permission-code="user.company.patch"
        other-permission-code="user.company.get"
        other-edit-permission-code="user.company.patch"
    ></manufacturer-detail>
    <customer-detail
        v-if="belong_type === 'customer'"
        :customer-id="belong_id"
        source="user-center"
        account-permission-code="user.company.get"
        account-edit-permission-code="user.company.patch"
        other-permission-code="user.company.get"
        other-edit-permission-code="user.company.patch"
    ></customer-detail>
  </Layout>

</template>
<style scoped>

</style>
